module.exports = __webpack_public_path__ + "img/cart_empty.2f058a72.png";